/**
 * These functions can be used before flights are initialized and should not contain any flight checks.
 */

/* eslint-disable-next-line @typescript-eslint/no-restricted-imports -- (https://aka.ms/OWALintWiki)
 * Need to use Dexie.exists
 *	> 'dexie' import is restricted from being used. Importing from dexie is allowed but needs an additional approver */
import Dexie from "dexie";
import { doesDatabaseExistInStorageBucket } from "owa-storage-buckets";
import { BUCKET_NAME, DATABASE_NAME } from "./constants";

export function doesLegacyDbExist(databaseName: string = DATABASE_NAME): Promise<boolean> {
    return Dexie.exists(databaseName);
}

export function doesBucketDbExist(bucketName: string = BUCKET_NAME, databaseName: string = DATABASE_NAME): Promise<boolean> {
    return doesDatabaseExistInStorageBucket(bucketName, databaseName);
}

export async function doesAnyDbExist(bucketName: string = BUCKET_NAME, databaseName: string = DATABASE_NAME): Promise<boolean> {
    const [exists, existsLegacy] = await Promise.all([
        doesBucketDbExist(bucketName, databaseName),
        doesLegacyDbExist(databaseName),
    ]);
    return exists || existsLegacy;
}
